import apiFetch from '../apiFetch'

export default function (dossierServiceId, dossierService, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossierService/${dossierServiceId}`, method: 'PUT', body: dossierService, token: token, lastAccessDate })
}
